import Text from '../components/Text';
import { createSignal, onMount } from "solid-js";
import { useNavigate } from '@solidjs/router';
import styles from './Login.module.css';

export default function Login() {
    const navigate = useNavigate();
    const [redirectUri, setRedirectUri] = createSignal<string | null>(null);
    const [nonce, setNonce] = createSignal<string | null>(null);

    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUriParam = urlParams.get("redirectUri");
        setRedirectUri(redirectUriParam);
        const n = generateNonce();
        setNonce(n);
        storeCookie(n, JSON.stringify({ next: redirectUriParam ? redirectUriParam : "/me" }), 5);
    });

    function storeCookie(name: string, value: string, minutes: number) {
        const expires = new Date();
        expires.setTime(expires.getTime() + minutes * 60 * 1000);
        document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
    }

    function generateNonce() {
        return Math.random().toString(36).substring(2);
    }

    const msAuthHref = () =>
        "https://login.live.com/oauth20_authorize.srf?client_id=db00ca2a-76d2-47ce-9c01-5f65cfab200a"
        + "&response_type=code"
        + "&redirect_uri=" + encodeURIComponent(window.location.origin + "/oauth/ms/callback")
        + "&scope=XboxLive.signin%20offline_access"
        + "&prompt=select_account"
        + (nonce() ? "&state=" + encodeURIComponent(nonce()!) : "");

    return (
        <div class={styles.page}>
            <div class={styles.bgGradient} />
            <div class={`${styles.orb} ${styles.orb1}`} />
            <div class={`${styles.orb} ${styles.orb2}`} />

            <div class={styles.card}>
                <img src="/vektor_ico.svg" alt="Vektor" class={styles.logo} />
                <h1 class={styles.title}><Text val="LOGIN_WELCOME_TITLE" /></h1>
                <p class={styles.subtitle}><Text val="LOGIN_WELCOME_SUB" /></p>

                <a class={styles.msLoginLink} href={msAuthHref()}>
                    <i class="fa-brands fa-microsoft" />
                    <span><Text val="LOGIN_WITH_MICROSOFT" /></span>
                </a>

                <button
                    type="button"
                    class={styles.secondaryBtn}
                    onClick={() => {
                        const url = redirectUri()
                            ? `/account-switcher?redirectUri=${encodeURIComponent(redirectUri()!)}`
                            : '/account-switcher';
                        navigate(url);
                    }}
                >
                    <i class="fa-solid fa-users" />
                    <span><Text val="SWITCH_ACCOUNT" /></span>
                </button>

                <p class={styles.legal}>
                    <Text val="LOGIN_LEGAL_PRE" />
                    {" "}
                    <a href="/datenschutz"><Text val="FOOTER_PRIVACY" /></a>
                    {" "}
                    <Text val="LOGIN_LEGAL_AND" />
                    {" "}
                    <a href="/security"><Text val="FOOTER_SECURITY" /></a>
                    .
                </p>
            </div>
        </div>
    );
}
